export enum BalanceShopItemTypeEnum {
    needle ='needle',
    combo = 'combo',
    thread = 'thread'
}

export interface IBalanceManager {
    getShopItemPrice(type: BalanceShopItemTypeEnum): number;
    getPicturePrice(size: number): number;
    getPictureReward(size: number): number;
    isPictureRewardAvaliable(size: number): boolean;
    getBoxReward(): number;
}

export const initBalanceManager = (instance: IBalanceManager) => {
    return
}
